/**
 * Checks if the URL has the same origin as the current window.
 * Useful for determining if an image can be downloaded directly
 * using <a download="">.
 */
export const isSameOrigin = (url: string) => {
  const loc = window.location
  const anchor = document.createElement('a')
  anchor.href = url

  return (
    anchor.hostname === loc.hostname &&
    anchor.port === loc.port &&
    anchor.protocol === loc.protocol &&
    loc.protocol !== 'file:'
  )
}
